/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const CreateMeetingPage = lazyLoad(
  () => import('./index'),
  module => module.CreateMeetingPage
);
